module.exports = __webpack_public_path__ + "img/corporateVision-img1.2c90ce8d.png";